<template>
    <v-container fluid>
        <user-form
            :model="user"
            @saved="saved"
            :titlePrefix="$t('users-create.texts.title-prefix')"
        ></user-form>
    </v-container>
</template>

<script>
import UserModel from '@/models/User'
import UserForm from './Form'

export default {
    components: {
        'user-form': UserForm,
    },

    data: () => {
        return {
            user: new UserModel(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: 'users' })
        },
    },
}
</script>
